import React, { useEffect } from 'react';
import CloseImage from '../../assets/ic_close.png';
import { createMuiTheme, MuiThemeProvider, Snackbar, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import profile from '../../assets/ic _poli_homepage.png';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { setISODay } from 'date-fns';
import editProf from '../../assets/editProf.png';
import ImageUploader from 'react-images-upload';
import ErrorRequest from '../ErrorRequest';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function DetailPoli(props) {
    const classes = useStyles()
    let detail = props.detail;
    let { speciality, schedule } = detail
    const [referalCode, setReferalCode] = React.useState("")
    const [name, setName] = React.useState("")
    const [id, setID] = React.useState("") 
    const [deskripsi, setDeskripsi] = React.useState("")
    const [kode, setKode] = React.useState("")
    const [photo, setPhoto] = React.useState("")
    const [photo2, setPhoto2] = React.useState("")
    const [uploadVisible, setUploadVisible] = React.useState(false)
    const [visibleImage, setVisibleImage] = React.useState(false);
    const [visibleError, setVisibleError] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleSeeDetailImage, setVisibleSeeDetailImage] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("");
    const [statusAlert, setStatusAlert] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [pictures, setPicture] = React.useState([])
    const [pictures2, setPicture2] = React.useState([])
    const [data, setData] = React.useState([])
    const [textErrorKode, setTextErrorKode] = React.useState(null);
    const [errorKode, setErrorKode] = React.useState(false);
    const listEksekutif = [
        { value: "Ya", id: 1 },
        { value: "Tidak", id: 0 },
    ]
    const [isEksekutif, setIsEksekutif] = React.useState(null);

    useEffect(() => {
        getDetailPoli()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDetailPoli = () => {
        api.create().getDetailPoli(props.detail[6]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data[0]
                    setData(data)
                    console.log('---------------------------');
                    setID(data.id)
                    setName(data.name)
                    setKode(data.code)
                    setReferalCode(data.bpjs_reference_code === null ? "" : data.bpjs_reference_code)
                    setDeskripsi(data.desc === null ? "" : data.desc)
                    setPhoto(data.media_path === null ? "" : data.media_path)
                    setPhoto2(data.media_path2 === null ? "" : data.media_path2)
                    let idxEks = listEksekutif.findIndex((val) => val.id === data.is_executive)
                    if (idxEks > -1) {
                        setIsEksekutif(listEksekutif[idxEks])
                    }
                    // setSpecialityID(data.speciality[0].id)
                    forceUpdate()
                }
            }
        })
    }
    console.log(id, name);

    const handleEdit = () => {
        let formData = new FormData()
        if (name !== data.name) {
            formData.append('name', name)
        }
        formData.append('id', id)
        formData.append('desc', deskripsi)
        formData.append('code', kode)
        formData.append('bpjs_reference_code', referalCode)
        formData.append('is_executive', isEksekutif.id)
        if (pictures.length > 0) {
            formData.append('photo', pictures[0])
        }
        if (pictures2.length > 0) {
            formData.append('photo2', pictures2[0])
        }
        formData.append('remark', '')
        api.create().updatePoli(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    props.openAlert(true)
                    props.messageAlert(response.data.message)
                    props.statusAlert("Succes")
                    props.onClose()
                    props.getData()
                } else {
                    if (response.data.data) {
                        if (response.data.data.photo2) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data.photo2)
                            setStatusAlert("warning")
                        } else if (response.data.data.name) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data.name)
                            setStatusAlert("warning")
                        } else if (response.data.data.code) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data.code)
                            setStatusAlert("warning")
                        } else {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("warning")
                        }
                    } else {
                        setVisibleError(true)
                        setErrorMessage(response.data.data.name)
                    }
                }
            }
        })

    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const columns = [
        {
            name: 'schedule',
            label: 'Schedule',
            option: {
                customHeadRender: (columnMeta) => (
                    <TableCell>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                // customBodyRender: (val, tableMeta) => {
                //     return (
                //         <div>

                //         </div>
                //     )
                // }
            }
        }
    ]

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------1');
        console.log(pictureFiles);
        setPhoto(pictureDataURLs)
        setPicture(pictureFiles)
    }

    const uploadFoto = () => {
        setUploadVisible(false)
    }

    const onDrop2 = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs)
        setPicture2(pictureFiles)
        setPhoto2(pictureFiles[0].name)
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Data Klinik</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ margin: 'auto', width: 90, height: 90, backgroundColor: 'transparent', marginTop: 20, borderRadius: 50 }}>
                    <img style={{ width: 88, height: 90 }} src={photo === "" ? profile : photo} />
                    <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer', backgroundColor: 'gray' }}
                        onClick={(e) => {
                            setPicture("")
                            setUploadVisible(true)
                        }}
                    />
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '100%' }}
                                id="id"
                                label="ID"
                                disabled
                                // id="outlined-read-only-input"
                                variant="filled"
                                value={id}
                                onChange={(e) => null}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            >
                            </TextField>
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <TextField
                                style={{ width: '100%' }}
                                required={true}
                                error={errorKode}
                                helperText={textErrorKode}
                                label="Kode Poliklinik"
                                placeholder={"input Kode Poliklinik"}
                                value={kode}
                                onChange={(e) => {
                                    setKode(e.target.value)
                                    setErrorKode(false)
                                    setTextErrorKode(null)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 24 }}
                                label="Detail Image"
                                placeholder={"Pilih Image"}
                                onClick={() => {
                                    setVisibleSeeDetailImage(true)
                                    // setVisibleImage(true)
                                    // setPicture2("")
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14, cursor: 'pointer'
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value="Lihat Detail"
                            />
                        </div>

                        <div style={{ marginTop: 15 }}>
                            <TextField
                                style={{ width: '100%' }}
                                id="Kode Referensi BPJS"
                                name="referalCode"
                                multiline
                                rowsMax={10}
                                label="Kode Referensi BPJS"
                                placeholder={"input kode referensi BPJS"}
                                onChange={(e) => {
                                    setReferalCode(e.target.value)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={referalCode}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <div className="">
                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: 8 }}>
                                <TextField
                                    style={{ width: '100%' }}
                                    id="name"
                                    label="Nama Klinik"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                >
                                </TextField>
                            </FormControl>
                        </div>
                        <div style={{ marginTop: 14 }}>
                            <TextField
                                style={{ width: '100%' }}
                                id="deskripsi"
                                name="deksripsi"
                                multiline
                                rowsMax={10}
                                label="Deskripsi"
                                placeholder={"input deskripsi"}
                                onChange={(e) => setDeskripsi(e.target.value)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={deskripsi}
                            />
                        </div>
                        <Autocomplete
                            options={listEksekutif}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setIsEksekutif(newInputValue)
                            }}
                            style={{ marginTop: 24 }}
                            value={isEksekutif}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Eksekutif"
                                />
                            }
                        />
                    </div>

                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleEdit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
            {
                visibleSeeDetailImage ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto', width: 90, height: 90, backgroundColor: 'transparent', marginTop: 20, borderRadius: 50 }}>
                                <img style={{ width: 88, height: 90 }} src={photo2} />
                                <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer', backgroundColor: 'gray' }}
                                    onClick={(e) => {
                                        // setPicture("")
                                        // setUploadVisible(true)
                                        setVisibleImage(true)
                                        setPicture2("")
                                    }}
                                />
                            </div>
                            <div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                <div onClick={() => setVisibleSeeDetailImage(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {uploadVisible && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setUploadVisible(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {visibleImage && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleImage(false)
                                        setPicture2("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures2.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop2}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures2.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setVisibleImage(false)}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}
            {
                visibleError ?
                    <ErrorRequest
                        close={() => setVisibleError(false)}
                        message={errorMessage}
                    />
                    : null
            }
        </div>
    )
}